import { Link, type LinkProps } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { localizedRoutes, type RouteKey } from '@/i18n/routes'
import type { SupportedLanguage } from '@/i18n'

interface LocalizedLinkProps extends Omit<LinkProps, 'to'> {
  to: RouteKey | string
}

export function LocalizedLink({ to, children, ...props }: LocalizedLinkProps) {
  const { i18n } = useTranslation()
  const currentLang = i18n.language as SupportedLanguage

  // Separate query string from route key (e.g. "products?category=panettoni")
  const [routePart, queryString] = to.split('?')
  const suffix = queryString ? `?${queryString}` : ''

  let path: string

  if (routePart in localizedRoutes) {
    const routeKey = routePart as RouteKey
    const localizedPath = localizedRoutes[routeKey][currentLang]
    path = localizedPath ? `/${currentLang}/${localizedPath}${suffix}` : `/${currentLang}${suffix}`
  } else if (routePart.startsWith('/')) {
    // Absolute path - add language prefix
    path = `/${currentLang}${routePart}${suffix}`
  } else if (routePart.startsWith('http') || routePart.startsWith('mailto:') || routePart.startsWith('tel:')) {
    // External link - pass through
    path = `${routePart}${suffix}`
  } else {
    // Relative path - add language prefix
    path = `/${currentLang}/${routePart}${suffix}`
  }

  return (
    <Link to={path} {...props}>
      {children}
    </Link>
  )
}
